@if (fieldState().invalid() && (fieldState().touched() || alwaysShowErrors())) {
  <ui-input-error>
    @for (error of fieldState().errors(); track $index) {
      <span>
        @if (error.message) {
          {{ error.message }}
        } @else {
          @switch (error.kind) {
            @case ('required') {
              {{ 'validators.required' | transloco }}
            }
            @case ('email') {
              {{ 'validators.email' | transloco }}
            }
            @case ('e164') {
              {{ 'validators.e164' | transloco }}
            }
            @case ('pattern') {
              {{ 'validators.pattern' | transloco }}
            }
            @case ('min') {
              {{ 'validators.min' | transloco }}
            }
            @default {
              {{ 'validators.unknown' | transloco }}
            }
          }
        }
      </span>
    }
  </ui-input-error>
}
